var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecordsMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_236_1",
    "data-name": "Component 236 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12976",
    "data-name": "Rectangle 12976",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18227",
    "data-name": "Group 18227",
    transform: "translate(-2448 -532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13197",
    "data-name": "Path 13197",
    d: "M21.4,9.662,17.988,6.25a.853.853,0,0,0-.6-.25H8.853A.853.853,0,0,0,8,6.853V22.21a.853.853,0,0,0,.853.853H20.8a.853.853,0,0,0,.853-.853V10.266A.853.853,0,0,0,21.4,9.662ZM17.384,18.8H12.266a.427.427,0,0,1,0-.853h5.119a.427.427,0,0,1,0,.853Zm0-2.559H12.266a.427.427,0,1,1,0-.853h5.119a.427.427,0,0,1,0,.853Zm0-2.559H12.266a.427.427,0,0,1,0-.853h5.119a.427.427,0,0,1,0,.853Zm0-2.559H12.266a.427.427,0,0,1,0-.853h5.119a.427.427,0,0,1,0,.853Z",
    transform: "translate(2445 529)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordsMenu);
export default __webpack_public_path__ + "static/media/records-menu.47b19b6d3cc3012f84da39b64e21bcf8.svg";
export { ForwardRef as ReactComponent };